import auth from '@/router/auth'
import CategoryBlogIndex from '@/components/attribute-values/Index'
import CategoryBlogCreate from '@/components/attribute-values/Create'
import CategoryBlogUpdate from '@/components/attribute-values/Update'
import CategoryBlogShow from '@/components/attribute-values/Show'

export default [
  {
    path: '/attribute-values',
    name: 'attribute-values-index',
    component: CategoryBlogIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/attribute-values/create/:attribute_key_id/:attribute_key_name',
    name: 'attribute-values-create',
    component: CategoryBlogCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/attribute-values/update/:id',
    name: 'attribute-values-update',
    component: CategoryBlogUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/attribute-values/show/:id',
    name: 'attribute-values-show',
    component: CategoryBlogShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/attribute-values/router.js